var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "open_in_new_white_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M17.667,17.667H4.833V4.833H11.25V3H4.833A1.833,1.833,0,0,0,3,4.833V17.667A1.833,1.833,0,0,0,4.833,19.5H17.667A1.839,1.839,0,0,0,19.5,17.667V11.25H17.667ZM13.083,3V4.833h3.291L7.363,13.844l1.292,1.293,9.011-9.011V9.417H19.5V3Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenbtn);
export default __webpack_public_path__ + "static/media/openbtn.a6c89214bf8b4c54842a84186ae9026e.svg";
export { ForwardRef as ReactComponent };